
const actionsForNewUsers = ['CHOOSE_CALENDAR', 'SEND_TO_PHONE','ENTER_DETAILS','ALMOST_DONE','ALMOST_DONE_TIMEOUT'];

const dimension3Actions = ['CHOOSE_CALENDAR', 'ENTER_DETAILS', 'SUBSCRIBE_COMPLETE','ALMOST_DONE', 'ALMOST_DONE_TIMEOUT', 'SHARE'];

const calendarTags = {
    google: 'Google',
    android: 'Android',
    office365: 'Office 365',
    other: 'ICS Other',
    outlook: 'Outlook (Desktop)',
    windowsLive: 'Outlook.com (Web)',
    apple: 'Apple',
};

function getDimension1 (active, action) {
   const isReturning = !actionsForNewUsers.includes(action);
    if (active && isReturning) {
        return 'Returning';
    }
    return 'New';
}

function getDimension3 (calendar, action) {
    if (dimension3Actions.includes(action)) {
        return calendarTags[calendar];
    }
    return '';
}

export default function getGAParams (action) {
    const widget = this.widget;
    const flags = this.flags;
    const ua = this.userAgent;
    let dimension2 = 'Web';
    if (!flags.embedded) {
        dimension2 = widget.send_to_phone ? 'SMS' : 'Email';
    }
    const dimension4 = ua?.device?.model || ua?.os?.name;

    let publisher = this.widget.publisherId;
    if (!publisher) {
        publisher = this.widgetSettings.apikey;
    }
    const dimensions = {
        dimension1: getDimension1(flags.activeUser, action),
        dimension2,
        dimension4,
        dimension5: flags.docReferrer,
        dimension6: publisher,
        dimension7: widget.id,
    };
    
    const dimension3 = getDimension3(this.selectedCalendar, action);
    if (dimension3) {
        dimensions.dimension3 = dimension3;
    }

    this.gaParams = {
        publisher: this.widget.organization,
        dimensions,
    };
 
    console.log('getGAParams() ->  this.gaParams :',  this.gaParams);

}